import React, {FC, ReactNode} from "react";
import { Theme, useMediaQuery} from "@mui/material";
import {styled} from "@mui/material/styles";
import {PWMSideNavSection, usePWMNavSections} from "../PWMSideNavConfig";
import {useSettings} from "src/PWM/hooks/use-settings";
import {useMobileNav} from "src/layouts/dashboard/vertical-layout/use-mobile-nav";
import {MobileNav} from "src/layouts/dashboard/mobile-nav";
import PropTypes from "prop-types";
import {NavColor} from "../../types/settings";
import {PWMNavbar} from "src/PWM/components/nav/PWMNavbar";
import {PWMSideNav} from "src/PWM/components/nav/PWMSideNav";

export const PWMPortalLayout: React.FC<PortalProps> = (props) => {
  const settings = useSettings();
  const sections = usePWMNavSections();
  return (
    <PWMVerticalLayout sections={sections} navColor={settings.navColor} {...props} />
  )
}

interface PortalProps {}

// ported from layouts/dashboard/vertical-layout/index.tsx
const PWMVerticalLayout: FC<VerticalLayoutProps> = (props) => {
  const {children, sections, navColor} = props;
  const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'));
  const mobileNav = useMobileNav();

  return (
    <>
      <PWMNavbar onMobileNavOpen={mobileNav.handleOpen}/>
      {lgUp && (
        <PWMSideNav
          color={navColor}
          sections={sections}
        />
      )}
      {!lgUp && (
        <MobileNav
          color={navColor}
          onClose={mobileNav.handleClose}
          open={mobileNav.open}
          sections={sections}
        />
      )}
      <VerticalLayoutRoot>
        <VerticalLayoutContainer>
          {children}
        </VerticalLayoutContainer>
      </VerticalLayoutRoot>
    </>
  );
};

PWMVerticalLayout.propTypes = {
  children: PropTypes.node,
  navColor: PropTypes.oneOf<NavColor>(['blend-in', 'discreet', 'evident']),
  sections: PropTypes.array
};

interface VerticalLayoutProps {
  children?: ReactNode;
  navColor?: NavColor;
  sections?: PWMSideNavSection[];
}

const SIDE_NAV_WIDTH: number = 280;

const VerticalLayoutRoot = styled('div')(
  ({theme}) => ({
    display: 'flex',
    flex: '1 1 auto',
    maxWidth: '100%',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: SIDE_NAV_WIDTH
    }
  })
);

const VerticalLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  width: '100%'
});